import { useTheme } from '../contexts/ThemeContext';

export const useChartTheme = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return {
    gridStroke: isDark ? '#374151' : '#f1f5f9',
    axisStroke: isDark ? '#6B7280' : '#94a3b8',
    tickFill: isDark ? '#9CA3AF' : '#64748b',
    tooltipBg: isDark ? '#1F2937' : '#FFFFFF',
    tooltipBorder: isDark ? '#374151' : '#E5E7EB',
    tooltipText: isDark ? '#F9FAFB' : '#1F2937',
    tooltipSecondary: isDark ? '#D1D5DB' : '#64748b',
    cardBg: isDark ? 'bg-gray-800' : 'bg-white',
    cardBorder: isDark ? 'border-gray-700' : 'border-gray-200',
    isDark,
  };
};
